import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-icons'

Vue.use(Vuetify)

// Custom theme and icons
const opts = {
  theme: {
    themes: {
      light: {
        primary: '#007549',
        secondary: '#005533',
        accent: '#FEB616',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  icons: {
    iconfont: 'md'
  }
}

export default new Vuetify(opts)
